import * as React                         from 'react';

import { v4 as uuidv4                   } from 'uuid';

import { heicTo                         } from "heic-to";

import { useAlert                       } from 'react-alert';

import { useNavigate                    } from 'react-router-dom';

import Drawer                             from '@mui/material/Drawer';

import { PhotoProvider                  } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

import { ArrowBackVector                } from 'src/components/vector/arrow-back';
import { CircleQuestionVector           } from 'src/components/vector/circle-question';
import { CircleWarningVector            } from 'src/components/vector/circle-warning';
import { ScannerVector                  } from 'src/components/vector/scanner';
import { ArrowDownVector                } from 'src/components/vector/arrow-down';
import { DownloadVector                 } from 'src/components/vector/download';
import { ReloadVector                   } from 'src/components/vector/reload';
import { EyeShowVector                  } from 'src/components/vector/eye-show';
import { SharingVector                  } from 'src/components/vector/sharing';
import { CalculatorVector               } from 'src/components/vector/calculator';
import { TrashVector                    } from 'src/components/vector/trash';
import { CVDuplicateVector              } from 'src/components/vector/cv-duplicate';
import { CVBlurVector                   } from 'src/components/vector/cv-blur';
import { ThreeDotsSpinnerAnimatedVector } from 'src/components/vector/animate/three-dots-spinner';

import { IconButton                     } from 'src/components/common/icon-button';
import { Button                         } from 'src/components/common/button';
import { Typography                     } from 'src/components/common/typography';
import { Labeled                        } from 'src/components/common/labeled';
import { InputTextbox                   } from 'src/components/common/input/input-textbox';
import { InputMultiline                 } from 'src/components/common/input/input-multiline';
import { InputCalendar                  } from 'src/components/common/input/input-calendar';
import { Grow                           } from 'src/components/common/flex/grow';
import { TabItem,
         TabSwitch                      } from 'src/components/common/tab-switch';
import { TwoActionDialog                } from 'src/components/common/two-action-dialog';
import { Switch                         } from 'src/components/common/switch';
import { Loading                        } from 'src/components/common/loading';

import { ReferSelector,
         ReferSelectorItem              } from 'src/components/features/common/refer-selector';

import { PieceNumIdHelpDialog           } from 'src/components/features/inspection/edit/piecenumid-help-dialog';
import { PieceHelpDialog                } from 'src/components/features/inspection/edit/piece-help-dialog';
import { CarriageHelpDialog             } from 'src/components/features/inspection/edit/carriage-help-dialog';
import { SpecificationHelpDialog        } from 'src/components/features/inspection/edit/specification-help-dialog';
import { GroupAttHelpDialog             } from 'src/components/features/inspection/edit/groupatt-help-dialog';
import { Scanner                        } from 'src/components/features/inspection/edit/scanner';
import { AttachmentAdd                  } from 'src/components/features/inspection/edit/attachment-add';
import { AttachmentPhoto                } from 'src/components/features/inspection/edit/attachment-photo';
import { AttachmentDOC                  } from 'src/components/features/inspection/edit/attachment-doc';
import { CertDownloadDialog             } from 'src/components/features/inspection/edit/cert-download-dialog';
import { DefectCalcDialog               } from 'src/components/features/inspection/edit/defect-calc-dialog';

import { PieceEditLookAndFeel,
         Container,
         WarningAlert,
         HeaderContainer,
         FormContainer,
         FormRowElement,
         PhotoContainer,
         PhotoCVLegend,
         PhotoCVLegendItem,
         PhotoList,
         SubmitContainer,
         WeightContainer,
         MarriageShareContainer,
         Hr,
         CloseOutlineVectorBig, 
         PieceEditVariants,
         pieceedit_variants,     
         WeightColumn                   } from 'src/components/features/inspection/edit/piece-edit-dialog/ui';

import Util                               from 'src/services/util';
import Db                                 from 'src/services/db';
import api                                from 'src/services/api';
import * as types                         from 'src/services/api/types';
import { DefectType,
         ProductTypeKolpino,
         QCState                        } from 'src/services/api/types/inspection';
import { AccountRole, 
         FieldType, 
         FieldTypeUsage                 } from 'src/services/api/types/auth';
import { InspectionState                } from 'src/services/api/types/inspection';
import Constants                          from 'src/services/constants';

import { AppDispatch,
         useAppSelector, 
         useAppDispatch,
         storeApi                       } from 'src/store';

import { AsyncOpStatus,
         Nullable, 
         voidFunction                   } from 'src/common';



const TYPE_GENERAL = types.inspection.PieceFileType.GENERAL;
const TYPE_PHOTO = types.inspection.PieceFileType.PHOTO;
const TYPE_PDF = types.inspection.PieceFileType.PDF;
const MODE_NEW = types.inspection.PieceFileMode.NEW;
const MODE_DEL = types.inspection.PieceFileMode.DEL;

const SAVE_NOW_TRUE = { isSaveEditedPiece: true, isSaveEditedComplaint: false };
const SAVE_NOW_TRUE_APPLY = { isSaveEditedPiece: true, isSaveEditedComplaint: false, isApplyEditedPiece: true };
export const SAVE_NOW_FALSE = { isSaveEditedPiece: false, isSaveEditedComplaint: false };

type PieceEditFormElement = { lookAndFeel: PieceEditLookAndFeel; dispatch: AppDispatch; };

const InputUEModeSwitcher: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const isPiece = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsPiece);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;
  const inspectionState = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralInspectionState);

  const [isConfirmOpened, setIsConfirmOpened] = React.useState<boolean>(false);
  const [confirmedTab, setConfirmedTab] = React.useState<string>('');

  const items = [
    { id: 'id', label: 'Идентификац. №' },
    { id: 'piece', label: account.isWireRod ? '№ партии/плавки' : '№ плавки' }
  ];
  const item = isPiece ? items[1] : items[0];

  const isDisabled = inspectionState === InspectionState.EDIT;

  const onModeSwitchHandler = (tab: TabItem) => {
    setConfirmedTab(tab.id);
    setIsConfirmOpened(true);
  }

  const onConfirmAcceptHandler = () => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedIsPieceChanged(confirmedTab === 'piece'));
    setIsConfirmOpened(false);
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onConfirmCancelHandler = () => {
    setIsConfirmOpened(false);
  }

  return (
    <React.Fragment>
      <TwoActionDialog
        variant = { lookAndFeel.modeSwitchConfirmDialogVariant }
        opened = { isConfirmOpened }
        caption = 'Внимание!'
        message = 'При переключении данные о позиции будут частично стерты'
        onCancel = { onConfirmCancelHandler }
        onAction = { onConfirmAcceptHandler }
      />
      <TabSwitch
        variant = { lookAndFeel.modeSwitcherVariant }
        items = { items }
        value = { item }
        isDisabled = { isDisabled }
        onChange = { onModeSwitchHandler }
      />
    </React.Fragment>
  )
}

const ProductType: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const productType = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedProductType);

  if (productType === null || productType === '')
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = 'Вид продукции'>
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${productType}` }
        isDisabled
        onChange = { voidFunction }
      />
    </Labeled>
  )
}

const DirtyWagons: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const carriage = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCarriage);
  const carriageError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCarriageError);
  const carriageQcsInError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCarriageQcsInError);
  const qcs = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCarriageQcs);
  const carriageInError = (qcs ?? []).some((qc) => carriageQcsInError.includes(`${carriage}:${qc.qcNum}`));
  const inspectionState = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralInspectionState);

  const [isHelpOpened, setIsHelpOpened] = React.useState<boolean>(false);
  const [isScannerOpened, setIsScannerOpened] = React.useState<boolean>(false);
  const [confirmDeleteOpened, setConfirmDeleteOpened] = React.useState<boolean>(false);
  const [actionCertIndex, setActionCertIndex] = React.useState<number>(0);

  const isDisabled = inspectionState === InspectionState.EDIT;

  const onOpenHelpDialogHandler = () => {
    setIsHelpOpened(true);
  }

  const onHelpCloseHandler = () => {
    setIsHelpOpened(false);
  }

  const onScannerTapHandler = (index: number) => {
    setActionCertIndex(index);
    setIsScannerOpened(true);
  }

  const onTrashTapHandler = (index: number) => {
    setActionCertIndex(index);
    setConfirmDeleteOpened(true);
  }

  const onCancelDeleteCertHandler = () => {
    setConfirmDeleteOpened(false);
  }

  const onAcceptDeleteCertHandler = () => {
    setConfirmDeleteOpened(false);
    dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageCertDeleted(actionCertIndex));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onAddCertHandler = () => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageCertAdded());
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  return (
    <React.Fragment>
      <Labeled variant = { lookAndFeel.labeledVariant } label = 'Номер вагона' isRequired>
        <FormRowElement lookAndFeel = { lookAndFeel }>
          <InputTextbox
            variant = { lookAndFeel.textboxVariant }
            value = { `${carriage ?? ''}` }
            isError = { carriageError !== '' || carriageInError }
            isDisabled = { isDisabled }
            hint = { carriageError }
            maxLength = { Constants.PIECE_CARRIAGE_LENGTH_MAX }
            customIcon = { carriage === null ? <CircleQuestionVector className = 'circle-question' /> : undefined }
            onCustomIconTap = { onOpenHelpDialogHandler }
            valueTransformer = { Util.selectDigitsFromString }
            onChange = { (value) => {
              dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageChanged(value));
              setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
            }}
            onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageErrorFixed()) }
          />
        </FormRowElement>
      </Labeled>
      {(qcs ?? []).map((cert, index) => (
        <React.Fragment>
          <Hr lookAndFeel = { lookAndFeel } />
          <FormRowElement lookAndFeel = { lookAndFeel }>
            <Typography variant = { lookAndFeel.topoDWCert }>{ `Сертификат качества ${index + 1}` }</Typography>
            {!isDisabled && (qcs ?? []).length > 1 && (
              <IconButton variant = { lookAndFeel.trashButtonVariant } isTapAllowed onTap = { () => onTrashTapHandler(index) }>
                <TrashVector />
              </IconButton>
            )}
          </FormRowElement>
          <Labeled variant = { lookAndFeel.labeledVariant } label = '№ сертификата качества' isRequired>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { `${cert.qcNum ?? ''}` }
                isError = { carriageQcsInError.includes(`${carriage}:${cert.qcNum}`) }
                isDisabled = { isDisabled }
                maxLength = { Constants.PIECE_CARRIAGE_QC_LENGTH_MAX }
                valueTransformer = { Util.selectDigitsFromString }
                onChange = { (value) => {
                  dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageCertChanged({ index, value }));
                  setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
                }}
              />
              {!isDisabled && (
                <IconButton variant = { lookAndFeel.scannerButtonVariant } isTapAllowed onTap = { () => onScannerTapHandler(index) }>
                  <ScannerVector />
                </IconButton>
              )}
            </FormRowElement>
          </Labeled>
        </React.Fragment>
      ))}
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <Button
          variant = { lookAndFeel.addCertButtonVariant }
          onTap = { onAddCertHandler }
          isDisabled = { isDisabled }
          label = 'Добавить сертификат'
        />
      </FormRowElement>
      <Hr lookAndFeel = { lookAndFeel } />
      {isScannerOpened && (
        <Scanner
          variant = { lookAndFeel.scannerVariant }
          onCancel = { () => { console.log('cancel'); setIsScannerOpened(false); } }
          onDecode = { (code) => {
            setIsScannerOpened(false);
            dispatch(storeApi.inspection.edit.actions.pieceEditedCarriageCertChanged({ index: actionCertIndex, value: code }));
            setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
        />
      )}
      <CarriageHelpDialog
        variant = { lookAndFeel.carriageHelpVariant }
        opened = { isHelpOpened }
        onClose = { onHelpCloseHandler }
      />
      <TwoActionDialog 
        variant = { lookAndFeel.deleteDWCertDialogVariant } 
        opened = { confirmDeleteOpened }
        caption = 'Удалить сертификат качества?'
        onCancel = { onCancelDeleteCertHandler }
        onAction = { onAcceptDeleteCertHandler }
      />
    </React.Fragment>
  )
}

const Term: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const specification = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedSpecificationNum);
  const specificationError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedSpecificationNumError);
  const specificationPosInError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedSpecificationPosInError);
  const isAllPoses = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsAllPoses);
  const metalDelivered = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedMetalDelivered);
  const poses = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedSpecificationPoses);
  const specificationInError = (poses ?? []).some((pos) => specificationPosInError.includes(`${specification}:${pos.pos}`));
  const inspectionState = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralInspectionState);

  const [isHelpOpened, setIsHelpOpened] = React.useState<boolean>(false);
  const [isScannerOpened, setIsScannerOpened] = React.useState<boolean>(false);
  const [confirmDeleteOpened, setConfirmDeleteOpened] = React.useState<boolean>(false);
  const [deliverReferOpened, setDeliverReferOpened] = React.useState<boolean>(false);
  const [unitReferOpened, setUnitReferOpened] = React.useState<boolean>(false);
  const [actionPosIndex, setActionPosIndex] = React.useState<number>(-1);

  const { Full, Not, Partial } = types.inspection.PieceMetalDelivered;
  const deliverReferItems: ReferSelectorItem[] = [
    { id: `${Full}`, label: 'Полностью' },
    { id: `${Partial}`, label: 'Частично' },
    { id: `${Not}`, label: 'Не доставлен' },
  ]
  const unitReferItems: ReferSelectorItem[] = [
    { id: `2`, label: 'т' },
    { id: `3`, label: 'шт' },
  ]

  const isDisabled = inspectionState === InspectionState.EDIT;

  const onOpenHelpDialogHandler = () => {
    setIsHelpOpened(true);
  }

  const onHelpCloseHandler = () => {
    setIsHelpOpened(false);
  }

  const onScannerTapHandler = () => {
    setIsScannerOpened(true);
  }

  const onTrashTapHandler = (index: number) => {
    setActionPosIndex(index);
    setConfirmDeleteOpened(true);
  }

  const onCancelDeletePosHandler = () => {
    setConfirmDeleteOpened(false);
  }

  const onAcceptDeletePosHandler = () => {
    setConfirmDeleteOpened(false);
    dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosDeleted(actionPosIndex));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onAddPosHandler = () => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosAdded());
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onOpenMetallDeliveredReferHandler = (index: number) => {
    setActionPosIndex(index);
    setDeliverReferOpened(true);
  }

  const onOpenUnitReferHandler = (index: number) => {
    setActionPosIndex(index);
    setUnitReferOpened(true);
  }

  const onChangeMetallDeliveredReferHandler = React.useCallback(
    (value: ReferSelectorItem) => {
      if (actionPosIndex === -1)
      {
        dispatch(storeApi.inspection.edit.actions.pieceEditedMetalDeliveredChanged(parseInt(value.id, 10)));
      }
      else
      {
        dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosMetalDeliveredChanged({
          index: actionPosIndex,
          value: parseInt(value.id, 10)
        }));
      }
      setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
    },
    [actionPosIndex, dispatch]
  )

  const onChangeUnitReferHandler = React.useCallback(
    (value: ReferSelectorItem) => {
      dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosUnitChanged({
        index: actionPosIndex,
        value: { id: parseInt(value.id), title: value.label, isInteger: value.id === '2' ? false : true },
      }));
      setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
    },
    [actionPosIndex, dispatch]
  )

  return (
    <React.Fragment>
      <Labeled variant = { lookAndFeel.labeledVariant } label = 'Номер спецификации' isRequired>
        <FormRowElement lookAndFeel = { lookAndFeel }>
          <InputTextbox
            variant = { lookAndFeel.textboxVariant }
            value = { `${specification ?? ''}` }
            isError = { specificationError !== '' || specificationInError }
            isDisabled = { isDisabled }
            hint = { specificationError }
            maxLength = { Constants.PIECE_SPECIFICATION_NUM_LENGTH_MAX }
            customIcon = { specification === null ? <CircleQuestionVector className = 'circle-question' /> : undefined }
            onCustomIconTap = { onOpenHelpDialogHandler }
            onChange = { (value) => {
              dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationNumChanged(value));
              setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
            }}
            onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationNumErrorFixed()) }
          />
          {!isDisabled && (
            <IconButton variant = { lookAndFeel.scannerButtonVariant } isTapAllowed onTap = { () => onScannerTapHandler() }>
              <ScannerVector />
            </IconButton>
          )}
        </FormRowElement>
      </Labeled>
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <Typography variant = { lookAndFeel.topoSwitchLabelTypo }>Весь заказ</Typography>
        <Switch
          variant = { lookAndFeel.topoSwitchVariant }
          value = { isAllPoses ?? false }
          onChange = { (checked) => {
            dispatch(storeApi.inspection.edit.actions.pieceEditedIsAllPosesChanged(checked));
            setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
        />
      </FormRowElement>
      {isAllPoses && (
        <Labeled variant = { lookAndFeel.labeledVariant } label = 'Металл доставлен' isRequired>
          <FormRowElement lookAndFeel = { lookAndFeel }>
            <InputTextbox
              variant = { lookAndFeel.textboxVariant }
              value = { deliverReferItems.find((item) => item.id === `${metalDelivered}`)?.label ?? '' }
              readOnly = { isDisabled }
              customIcon = { <ArrowDownVector /> }
              onChange = { voidFunction }
              onCustomIconTap = { () => onOpenMetallDeliveredReferHandler(-1) }
            />
          </FormRowElement>
        </Labeled>
      )}
      {!isAllPoses && (poses ?? []).map((position, index) => (
        <React.Fragment>
          <Hr lookAndFeel = { lookAndFeel } />
          <FormRowElement lookAndFeel = { lookAndFeel }>
            <Typography variant = { lookAndFeel.topoDWCert }>{ `Позиция ${index + 1}` }</Typography>
            {!isDisabled && (poses ?? []).length > 1 && (
              <IconButton variant = { lookAndFeel.trashButtonVariant } isTapAllowed onTap = { () => onTrashTapHandler(index) }>
                <TrashVector />
              </IconButton>
            )}
          </FormRowElement>
          <Labeled variant = { lookAndFeel.labeledVariant } label = 'Позиция' isRequired>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { `${position.pos ?? ''}` }
                isError = { specificationPosInError.includes(`${specification}:${position.pos}`) }
                isDisabled = { isDisabled }
                maxLength = { Constants.PIECE_SPECIFICATION_NUM_LENGTH_MAX }
                valueTransformer = { Util.selectDigitsFromString }
                onChange = { (value) => {
                  dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosPosChanged({ index, value }));
                  setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
                }}
              />
            </FormRowElement>
          </Labeled>
          <Labeled variant = { lookAndFeel.labeledVariant } label = 'Металл доставлен' isRequired>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { deliverReferItems.find((item) => item.id === `${position.metalDelivered}`)?.label ?? '' }
                readOnly = { isDisabled }
                customIcon = { <ArrowDownVector /> }
                onChange = { voidFunction }
                onCustomIconTap = { () => onOpenMetallDeliveredReferHandler(index) }
              />
            </FormRowElement>
          </Labeled>
          <Labeled variant = { lookAndFeel.labeledVariant } label = 'Объем, не поставленный в срок' isRequired>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { `${position.__volumeDeliveredTime ?? ''}` }
                isError = { specificationPosInError.includes(`${specification}:${position.pos}`) }
                isDisabled = { isDisabled }
                maxLength = { Constants.PIECE_VOLUMEDELIVEREDTIME_LENGTH_MAX }
                valueTransformer = { (value: string) => position.unit.isInteger ? Util.selectDigitsFromString(value) : Util.selectDigitsAndDotFromStringN_M(value, 8, 3) }
                onChange = { (value) => {
                  dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosVolumeDeliveredTimeChanged({ index, value }));
                  setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
                }}
              />
            </FormRowElement>
          </Labeled>
          <Labeled variant = { lookAndFeel.labeledVariant } label = 'Продажная единица' isRequired>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { unitReferItems.find((item) => item.id === `${position.unit.id}`)?.label ?? '' }
                readOnly = { isDisabled }
                isDisabled = { isDisabled }
                customIcon = { <ArrowDownVector /> }
                onChange = { voidFunction }
                onCustomIconTap = { () => onOpenUnitReferHandler(index) }
              />
            </FormRowElement>
          </Labeled>
          <Labeled variant = { lookAndFeel.labeledVariant } label = 'Кол-во дней просрочки'>
            <FormRowElement lookAndFeel = { lookAndFeel }>
              <InputTextbox
                variant = { lookAndFeel.textboxVariant }
                value = { `${position.daysOverdue ?? ''}` }
                isError = { specificationPosInError.includes(`${specification}:${position.pos}`) }
                isDisabled = { isDisabled }
                maxLength = { Constants.PIECE_DAYSOVERDUE_LENGTH_MAX }
                valueTransformer = { Util.selectDigitsFromString }
                onChange = { (value) => {
                  dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationPosDaysOverdueChanged({ index, value }));
                  setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
                }}
              />
            </FormRowElement>
          </Labeled>
        </React.Fragment>
      ))}
      {!isAllPoses && (
        <FormRowElement lookAndFeel = { lookAndFeel }>
          <Button
            variant = { lookAndFeel.addPosButtonVariant }
            onTap = { onAddPosHandler }
            isDisabled = { isDisabled }
            label = 'Добавить позицию'
          />
        </FormRowElement>
      )}
      <Hr lookAndFeel = { lookAndFeel } />
      {isScannerOpened && (
        <Scanner
          variant = { lookAndFeel.scannerVariant }
          onCancel = { () => { console.log('cancel'); setIsScannerOpened(false); } }
          onDecode = { (code) => {
            setIsScannerOpened(false);
            dispatch(storeApi.inspection.edit.actions.pieceEditedSpecificationNumChanged(code));
            setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
        />
      )}
      <SpecificationHelpDialog
        variant = { lookAndFeel.specificationHelpVariant }
        opened = { isHelpOpened }
        onClose = { onHelpCloseHandler }
      />
      <TwoActionDialog 
        variant = { lookAndFeel.deleteDWCertDialogVariant } 
        opened = { confirmDeleteOpened }
        caption = 'Удалить позицию?'
        onCancel = { onCancelDeletePosHandler }
        onAction = { onAcceptDeletePosHandler }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { deliverReferItems }
        isOpened = { deliverReferOpened }
        label = 'Металл доставлен'
        selectedId = { metalDelivered ? `${metalDelivered}` : null }
        onClose = { () => setDeliverReferOpened(false) }
        onSelect = { onChangeMetallDeliveredReferHandler }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { unitReferItems }
        isOpened = { unitReferOpened }
        label = 'Единица'
        selectedId = { null }
        onClose = { () => setUnitReferOpened(false) }
        onSelect = { onChangeUnitReferHandler }
      />
    </React.Fragment>
  )
}

const QmetId: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const qmetId = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedQmetId);
  const qmetIdError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedQmetIdError);
  const inspectionState = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralInspectionState);

  const [isHelpOpened, setIsHelpOpened] = React.useState<boolean>(false);
  const [isScannerOpened, setIsScannerOpened] = React.useState<boolean>(false);

  const isDisabled = inspectionState === InspectionState.EDIT;

  const onOpenHelpDialogHandler = () => {
    setIsHelpOpened(true);
  }

  const onHelpCloseHandler = () => {
    setIsHelpOpened(false);
  }

  const onScannerTapHandler = () => {
    setIsScannerOpened(true);
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = 'Идентификационный №' isRequired>
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <InputTextbox
          variant = { lookAndFeel.textboxVariant }
          value = { `${qmetId ?? ''}` }
          isError = { qmetIdError !== '' }
          isDisabled = { isDisabled }
          hint = { qmetIdError }
          maxLength = { Constants.PIECE_NUM_ID_LENGTH_MAX }
          customIcon = { qmetId === null ? <CircleQuestionVector className = 'circle-question' /> : undefined }
          onCustomIconTap = { onOpenHelpDialogHandler }
          valueTransformer = { Util.selectDigitsFromString }
          onChange = { (value) => {
            dispatch(storeApi.inspection.edit.actions.pieceEditedQmetIdChanged(value));
            setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
          onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedQmetIdErrorFixed()) }
        />
        {!isDisabled && (
          <IconButton variant = { lookAndFeel.scannerButtonVariant } isTapAllowed onTap = { onScannerTapHandler }>
            <ScannerVector />
          </IconButton>
        )}
      </FormRowElement>
      <PieceNumIdHelpDialog
        variant = { lookAndFeel.piecenumidHelpVariant }
        opened = { isHelpOpened }
        onClose = { onHelpCloseHandler }
      />
      {isScannerOpened && (
        <Scanner
          variant = { lookAndFeel.scannerVariant }
          onCancel = { () => { console.log('cancel'); setIsScannerOpened(false); } }
          onDecode = { (code) => {
            setIsScannerOpened(false);
            dispatch(storeApi.inspection.edit.actions.pieceEditedQmetIdChanged(code));
            setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
        />
      )}
    </Labeled>
  )
}

const Heat: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;
  const authSelectors = storeApi.auth.common.selectors;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const heat = useAppSelector(inspectionSelectors.selectPieceEditedHeat);
  const heatError = useAppSelector(inspectionSelectors.selectPieceEditedHeatError);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);

  const account = useAppSelector(authSelectors.selectAccount)!;
  const piece = useAppSelector(inspectionSelectors.selectPieceEditedPiece);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);

  const isKolpino = useAppSelector(authSelectors.selectIsKolpino);
  const isEditState = inspectionState === InspectionState.EDIT;
  const isWireRod = account.isWireRod;

  let isRequired = false;
  let isDisabled = false;
  let isHide = false;

  const { MECHANICAL_ENGINEERING_PART, PROCESSED_SHEET } = ProductTypeKolpino;

  if (isKolpino)
  {
    isRequired = false;
    isDisabled = (!isPiece && fromEntryAccounting) || isEditState;
    isHide = productTypeKolpinoId === null || [MECHANICAL_ENGINEERING_PART, PROCESSED_SHEET].includes(productTypeKolpinoId);
  }
  else
  {
    isRequired = !isWireRod || (isWireRod && piece !== null);
    isDisabled = (!isPiece && fromEntryAccounting) || isEditState;
    isHide = false;
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = '№ плавки' isRequired = { isRequired }>
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${heat ?? ''}` }
        isError = { heatError !== '' }
        isDisabled = { isDisabled }
        hint = { heatError }
        valueTransformer = { Util.selectHeatAllowedCharsFromString }
        onChange = { (value) => {
          dispatch(inspectionActions.pieceEditedHeatChanged(value));
          setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
        onFocus = { () => dispatch(inspectionActions.pieceEditedHeatErrorFixed()) }
      />
    </Labeled>
  )
}

const Piece: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;
  const authSelectors = storeApi.auth.common.selectors;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const piece = useAppSelector(inspectionSelectors.selectPieceEditedPiece);
  const pieceError = useAppSelector(inspectionSelectors.selectPieceEditedPieceError);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);

  const account = useAppSelector(authSelectors.selectAccount)!;
  const groupAtt = useAppSelector(inspectionSelectors.selectPieceEditedGroupAtt);
  const qcNum = useAppSelector(inspectionSelectors.selectPieceEditedQCNum);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);

  const isKolpino = useAppSelector(authSelectors.selectIsKolpino);
  const isEditState = inspectionState === InspectionState.EDIT;
  const isWireRod = account.isWireRod;

  let isRequired = false;
  let isDisabled = false;
  let isHide = false;
  let label = '';

  const { PROCESSED_SHEET, UNPROCESSED_SHEET } = ProductTypeKolpino;

  if (isKolpino)
  {
    isRequired = true;
    isDisabled = true;
    isHide = productTypeKolpinoId === null || [PROCESSED_SHEET, UNPROCESSED_SHEET].includes(productTypeKolpinoId);
    label = '№ листа';
  }
  else
  {
    isRequired = !isWireRod || (isWireRod && piece !== null);
    isDisabled = (!isPiece && fromEntryAccounting) || (isEditState || groupAtt !== null || qcNum !== null);
    isHide = false;
    label = '№ рулона/листа/трубы';
  }

  const [isHelpOpened, setIsHelpOpened] = React.useState<boolean>(false);

  const onOpenHelpDialogHandler = () => {
    setIsHelpOpened(true);
  }

  const onHelpCloseHandler = () => {
    setIsHelpOpened(false);
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = { label } isRequired = { isRequired }>
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <InputTextbox
          variant = { lookAndFeel.textboxVariant }
          value = { `${piece ?? ''}` }
          isError = { pieceError !== '' }
          hint = { pieceError }
          isDisabled = { isDisabled }
          customIcon = { piece === null ? <CircleQuestionVector className = 'circle-question' /> : undefined }
          onCustomIconTap = { onOpenHelpDialogHandler }
          onChange = { (value) => {
            dispatch(inspectionActions.pieceEditedPieceChanged(value));
            setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
          onFocus = { () => dispatch(inspectionActions.pieceEditedPieceErrorFixed()) }
        />
        <PieceHelpDialog
          variant = { lookAndFeel.pieceHelpVariant }
          opened = { isHelpOpened }
          onClose = { onHelpCloseHandler }
        />
      </FormRowElement>
    </Labeled>
  )
}

const GroupAtt: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;
  const authSelectors = storeApi.auth.common.selectors;

  const account = useAppSelector(authSelectors.selectAccount)!;

  const groupAtt = useAppSelector(inspectionSelectors.selectPieceEditedGroupAtt);
  const groupAttError = useAppSelector(inspectionSelectors.selectPieceEditedGroupAttError);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const qcNum = useAppSelector(inspectionSelectors.selectPieceEditedQCNum);
  const piece = useAppSelector(inspectionSelectors.selectPieceEditedPiece);
  const isKolpino = useAppSelector(authSelectors.selectIsKolpino);
  const isWireRod = account.isWireRod;
  const isEditState = inspectionState === InspectionState.EDIT;

  let isRequired = false;
  let isDisabled = false;
  let isHide = false;
  let label = '';

  if (isKolpino)
  {
    isRequired = true;
    isDisabled = isEditState;
    isHide = false;
    label = '№ партии по маркировке';
  }
  else
  {
    isRequired = groupAtt !== null || qcNum !== null;
    isDisabled = isEditState || piece !== null;
    isHide = !(isWireRod || groupAtt !== null);
    label = '№ партии аттестации';
  }

  const [isHelpOpened, setIsHelpOpened] = React.useState<boolean>(false);

  const onOpenHelpDialogHandler = () => {
    setIsHelpOpened(true);
  }

  const onHelpCloseHandler = () => {
    setIsHelpOpened(false);
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = { label } isRequired = { isRequired }>
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <InputTextbox
          variant = { lookAndFeel.textboxVariant }
          value = { `${groupAtt ?? ''}` }
          isError = { groupAttError !== '' }
          hint = { groupAttError }
          isDisabled = { isDisabled }
          customIcon = { groupAtt === null ? <CircleQuestionVector className = 'circle-question' /> : undefined }
          onCustomIconTap = { onOpenHelpDialogHandler }
          maxLength = { 25 }
          onChange = { (value) => {
            dispatch(inspectionActions.pieceEditedGroupAttChanged(value));
            setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
          onFocus = { () => dispatch(inspectionActions.pieceEditedGroupAttErrorFixed()) }
        />
        <GroupAttHelpDialog
          variant = { lookAndFeel.groupattHelpVariant }
          opened = { isHelpOpened }
          onClose = { onHelpCloseHandler }
        />
      </FormRowElement>
    </Labeled>
  )
}

const QCNum: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;
  const authSelectors = storeApi.auth.common.selectors;

  const account = useAppSelector(authSelectors.selectAccount)!;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const qcNum = useAppSelector(inspectionSelectors.selectPieceEditedQCNum);
  const qcState = useAppSelector(inspectionSelectors.selectPieceEditedQCState);
  const qcNumError = useAppSelector(inspectionSelectors.selectPieceEditedQCNumError);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const inspectionGuid = useAppSelector(inspectionSelectors.selectGeneralEditedGuid);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);

  const groupAtt = useAppSelector(inspectionSelectors.selectPieceEditedGroupAtt);
  const piece = useAppSelector(inspectionSelectors.selectPieceEditedPiece);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);
  const isSmc = useAppSelector(inspectionSelectors.selectPieceEditedIsSmc);
  const isKolpino = useAppSelector(authSelectors.selectIsKolpino);
  const isWireRod = account.isWireRod;
  const isEditState = inspectionState === InspectionState.EDIT;

  let isRequired = false;
  let isDisabled = false;
  let isHide = false;
  let isAllowCertDownload = false;

  if (isKolpino)
  {
    isRequired = true;
    isDisabled = (!isPiece && fromEntryAccounting) || isEditState;
    isHide = false;
    isAllowCertDownload = isDisabled && qcNum !== '' && productTypeKolpinoId === ProductTypeKolpino.UNPROCESSED_SHEET;
  }
  else
  {
    isRequired = groupAtt !== null || qcNum !== null;
    isDisabled = (!isPiece && fromEntryAccounting) || (isEditState || piece !== null || !(isWireRod || groupAtt !== null));
    isHide = !(isWireRod || groupAtt !== null) && qcNum === null;
    isAllowCertDownload = isDisabled && qcNum !== '' && !isSmc;
  }

  const checkCertRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (isAllowCertDownload && qcState === QCState.LOADING) 
    {
      if (!checkCertRef.current)
      {
        checkCertRef.current = true;
        dispatch(inspectionAsyncs.checkCertAsync({ inspectionGuid }));
      }
    }
  }, []);

  const downloadHandler = () => {
    if (qcNum !== null)
    {
      dispatch(inspectionAsyncs.downloadCertAsync({ qcNum }));
    }
  }

  const reloadHandler = () => {
    dispatch(inspectionAsyncs.checkCertAsync({ inspectionGuid }));
  }

  const showHandler = () => {
    if (qcNum !== null)
    {
      dispatch(inspectionAsyncs.viewCertAsync({ qcNum }));
    }
  }

  const sharingHandler = () => {
    if (qcNum !== null)
    {
      dispatch(inspectionAsyncs.shareCertAsync({ qcNum }));
    }
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = '№ сертификата качества' isRequired = { isRequired }>
      <FormRowElement lookAndFeel = { lookAndFeel }>
        <InputTextbox
          variant = { lookAndFeel.textboxVariant }
          value = { `${qcNum ?? ''}` }
          isError = { qcNumError !== '' }
          hint = { qcNumError }
          isDisabled = { isDisabled }
          onChange = { (value) => {
            dispatch(inspectionActions.pieceEditedQCNumChanged(value));
            setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
          }}
          onFocus = { () => dispatch(inspectionActions.pieceEditedQCNumErrorFixed()) }
        />
        { isAllowCertDownload && qcState === QCState.NONE && 
          <IconButton variant = { lookAndFeel.loadCertButtonBariant } isTapAllowed onTap = { downloadHandler }>
            <DownloadVector />
          </IconButton>
        }
        { isAllowCertDownload && qcState === QCState.LOADING && 
          <IconButton variant = { lookAndFeel.loadCertButtonBariant } isTapAllowed onTap = { reloadHandler }>
            <ReloadVector />
          </IconButton>
        }
        { isAllowCertDownload && qcState === QCState.LOADED && 
          <React.Fragment>
            <IconButton variant = { lookAndFeel.loadCertButtonBariant } isTapAllowed onTap = { showHandler }>
              <EyeShowVector />
            </IconButton>
            <IconButton variant = { lookAndFeel.loadCertButtonBariant } isTapAllowed onTap = { sharingHandler }>
              <SharingVector />
            </IconButton>
          </React.Fragment>
        }
      </FormRowElement>
    </Labeled>
  )
}

const KolpinoProductType: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);

  const isEditState = inspectionState === InspectionState.EDIT;

  const isDisabled = (!isPiece && fromEntryAccounting) || isEditState;

  const [referOpened, setReferOpened] = React.useState<boolean>(false);

  const items = [
    { id: `${ProductTypeKolpino.MECHANICAL_ENGINEERING_PART}`, label: 'Детали машиностроения' },
    { id: `${ProductTypeKolpino.PROCESSED_SHEET}`, label: 'Лист обработанный' },
    { id: `${ProductTypeKolpino.UNPROCESSED_SHEET}`, label: 'Лист не обработанный' },
  ];

  const productTypeKolpinoTitle = productTypeKolpinoId !== null ?
    items.find((item) => item.id === `${productTypeKolpinoId}`)?.label ?? ''
    :
    '';

  const onItemSelectedHandler = (item: ReferSelectorItem) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedProductTypeKolpinoIdChanged(parseInt(item.id, 10)));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = 'Вид продукции' isRequired >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { productTypeKolpinoTitle }
        readOnly
        onChange = { voidFunction }
        placeholder = ''
        customIcon = { <ArrowDownVector /> }
        isDisabled = { isDisabled }
        onCustomIconTap = { () => setReferOpened(true) }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = 'Вид продукции'
        selectedId = { productTypeKolpinoId ? `${productTypeKolpinoId}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </Labeled>
  )
}

const KolpinoPiece: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const alert = useAlert();

  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const piece = useAppSelector(inspectionSelectors.selectPieceEditedPiece);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);
  const groupAtt = useAppSelector(inspectionSelectors.selectPieceEditedGroupAtt);
  const qcNum = useAppSelector(inspectionSelectors.selectPieceEditedQCNum);

  const isEditState = inspectionState === InspectionState.EDIT;

  const { MECHANICAL_ENGINEERING_PART, UNPROCESSED_SHEET } = ProductTypeKolpino;

  const isDisabled = (!isPiece && fromEntryAccounting) || isEditState;
  const isHide = productTypeKolpinoId === null || [MECHANICAL_ENGINEERING_PART, UNPROCESSED_SHEET].includes(productTypeKolpinoId);

  const [referOpened, setReferOpened] = React.useState<boolean>(false);
  const [referSearched, setReferSearched] = React.useState<boolean>(false);
  const [referGroupAtt, setReferGroupAtt] = React.useState<string>('');
  const [referQCNum, setReferQCNum] = React.useState<string>('');
  const [referItems, setReferItems] = React.useState<types.inspection.KolpinoDataItem[]>([]);

  const items = React.useMemo(() => referItems.map((item) => ({
    id: `${item.piece ?? ''}`,
    label: `${item.piece ?? ''}`,
    sublabel: `${item.profileSize ?? ''}`,
  })), [referItems]);

  const onOpenReferSelectorHandler = () => {
    const groupAttForSelect = groupAtt ?? '';
    const qcNumForSelect = qcNum ?? '';

    if (!referSearched && (groupAttForSelect !== referGroupAtt || qcNumForSelect !== referQCNum))
    {
      setReferSearched(true);
      setReferGroupAtt(groupAttForSelect);
      setReferQCNum(qcNumForSelect);
      setReferItems([]);

      api.getInspectionDataKolpino({
        productTypeKolpinoId: ProductTypeKolpino.PROCESSED_SHEET,
        groupAtt: groupAtt ?? '',
        qc: qcNum ?? '',
      })
        .then((result) => {
          setReferSearched(false);
          setReferItems(
            result.filter((item) => item.piece !== null && item.piece !== '')
          );
          setReferOpened(true);
        })
        .catch((error) => {
          setReferSearched(false);
          alert.error(`Не удалось получить данные справочника. ${error}`);
        })
    }
    else
    {
      setReferOpened(true);
    }
  }

  const onItemSelectedHandler = (selectedItem: ReferSelectorItem) => {
    const item = referItems.find((item) => item.piece === selectedItem.id)!;

    dispatch(inspectionActions.pieceEditedKolpinoPieceChanged(item));
    
    setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = '№ листа' isRequired >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { piece ?? '' }
        readOnly
        onChange = { voidFunction }
        placeholder = ''
        customIcon = { referSearched ? <Loading variant='lightblue24' /> : <ArrowDownVector /> }
        isDisabled = { isDisabled }
        onCustomIconTap = { onOpenReferSelectorHandler }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = '№ листа'
        selectedId = { piece }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </Labeled>
  )
}

const KolpinoDrawNum: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const alert = useAlert();

  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;

  const isPiece = useAppSelector(inspectionSelectors.selectPieceEditedIsPiece);
  const drawNum = useAppSelector(inspectionSelectors.selectPieceEditedDrawNum);
  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);
  const fromEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralEditedFromEntryAccounting);
  const groupAtt = useAppSelector(inspectionSelectors.selectPieceEditedGroupAtt);
  const qcNum = useAppSelector(inspectionSelectors.selectPieceEditedQCNum);

  const isEditState = inspectionState === InspectionState.EDIT;

  const { PROCESSED_SHEET, UNPROCESSED_SHEET } = ProductTypeKolpino;

  const isDisabled = (!isPiece && fromEntryAccounting) || isEditState;
  const isHide = productTypeKolpinoId === null || [PROCESSED_SHEET, UNPROCESSED_SHEET].includes(productTypeKolpinoId);

  const [referOpened, setReferOpened] = React.useState<boolean>(false);
  const [referSearched, setReferSearched] = React.useState<boolean>(false);
  const [referGroupAtt, setReferGroupAtt] = React.useState<string>('');
  const [referQCNum, setReferQCNum] = React.useState<string>('');
  const [referItems, setReferItems] = React.useState<types.inspection.KolpinoDataItem[]>([]);

  const items = React.useMemo(() => referItems.map((item) => ({
    id: `${item.drawNum ?? ''}`,
    label: `${item.drawNum ?? ''}`,
    sublabel: `${item.piece ?? ''}`,
  })), [referItems]);

  const onOpenReferSelectorHandler = () => {
    const groupAttForSelect = groupAtt ?? '';
    const qcNumForSelect = qcNum ?? '';

    if (!referSearched && (groupAttForSelect !== referGroupAtt || qcNumForSelect !== referQCNum))
    {
      setReferSearched(true);
      setReferGroupAtt(groupAttForSelect);
      setReferQCNum(qcNumForSelect);
      setReferItems([]);

      api.getInspectionDataKolpino({
        productTypeKolpinoId: ProductTypeKolpino.MECHANICAL_ENGINEERING_PART,
        groupAtt: groupAtt ?? '',
        qc: qcNum ?? '',
      })
        .then((result) => {
          setReferSearched(false);
          setReferItems(
            result.filter((item) => item.drawNum !== null && item.drawNum !== '')
          );
          setReferOpened(true);
        })
        .catch((error) => {
          setReferSearched(false);
          alert.error(`Не удалось получить данные справочника. ${error}`);
        })
    }
    else
    {
      setReferOpened(true);
    }
  }

  const onItemSelectedHandler = (selectedItem: ReferSelectorItem) => {
    const item = referItems.find((item) => item.drawNum === selectedItem.id)!;

    dispatch(inspectionActions.pieceEditedKolpinoDrawChanged(item));
    
    setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isHide)
  {
    return null;
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = '№ чертежа' isRequired >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { drawNum ?? '' }
        readOnly
        onChange = { voidFunction }
        placeholder = ''
        customIcon = { referSearched ? <Loading variant='lightblue24' /> : <ArrowDownVector /> }
        isDisabled = { isDisabled }
        onCustomIconTap = { onOpenReferSelectorHandler }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = '№ чертежа'
        selectedId = { drawNum }
        isSearchable
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </Labeled>
  )
}

const CustomField: React.FC<PieceEditFormElement & { field: types.auth.FieldDescriptor }> = ({ field, lookAndFeel, dispatch }) => {
  const [referOpened, setReferOpened] = React.useState<boolean>(false);
  const [referItems, setReferItems] = React.useState<ReferSelectorItem[]>([]);

  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const customFields = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCustomFields);
  const customFieldsErrors = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCustomFieldsErrors);

  const fieldValue = customFields.find((item) => item.code === field.code)?.value;
  const fieldError = customFieldsErrors[field.code];

  React.useEffect(() => {
    if (field.refer !== null)
    {
      Db.getRefers()
        .then((refers) => {
          setReferItems(
            refers
              .filter((item) => item.referId === field.refer!.id)
              .map((item) => ({ id: item.title, label: item.title }))
          );
        })
        .catch((error) => {

        });
    }
  }, [field]);

  const onChangeValueHandler = (value: ReferSelectorItem) => {
    onChangeHandler(value.id);
  }

  const onChangeHandler = (value: string) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedCustomFieldChanged({
      id: field.id,
      code: field.code,
      value: value
    }));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  };

  if (field.typeUsage === FieldTypeUsage.Defect && isEntryAccounting)
  {
    return null;
  }

  if (field.typeUsage === FieldTypeUsage.EntryAccounting && !isEntryAccounting)
  {
    return null;
  }

  if (field.refer === null)
  {
    return (
      <Labeled 
        key = { field.code }
        variant = { lookAndFeel.labeledVariant }
        label = { field.title }
        isRequired = { !field.isOptional }
      >
        {field.fieldType === FieldType.String && (
          <InputTextbox
            variant = { lookAndFeel.textboxVariant }
            value = { fieldValue ?? '' }
            isError = { fieldError !== undefined }
            hint = { fieldError ?? '' }
            placeholder = { field.hint ?? '' }
            maxLength = { field.size }
            onChange = { onChangeHandler }
            onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCustomFieldErrorFixed(field.code)) }
          />
        )}

        {field.fieldType === FieldType.Int && (
          <InputTextbox
            variant = { lookAndFeel.textboxVariant }
            value = { fieldValue ?? '' }
            isError = { fieldError !== undefined }
            hint = { fieldError ?? '' }
            placeholder = { field.hint ?? '' }
            maxLength = { field.size }
            valueTransformer = { Util.selectDigitsFromString }
            onChange = { onChangeHandler }
            onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCustomFieldErrorFixed(field.code)) }
          />
        )}

        {field.fieldType === FieldType.Dec && (
          <InputTextbox
            variant = { lookAndFeel.textboxVariant }
            value = { fieldValue ?? '' }
            isError = { fieldError !== undefined }
            hint = { fieldError ?? '' }
            placeholder = { field.hint ?? '' }
            maxLength = { 11 + field.size }
            valueTransformer = { (rawValue: string) => Util.selectDigitsAndDotFromStringN_M(rawValue, 10, field.size) }
            onChange = { onChangeHandler }
            onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCustomFieldErrorFixed(field.code)) }
          />
        )}

        {field.fieldType === FieldType.Date && (
          <InputCalendar
            variant = { lookAndFeel.calendarVariant }
            value = { (fieldValue !== undefined && fieldValue !== '') ? Util.fromStringToDateFormat(fieldValue, 'DD.MM.YYYY') : null }
            isError = { fieldError !== undefined }
            hint = { fieldError ?? '' }
            placeholder = { field.hint ?? '' }
            onChange = { (value: Nullable<Date>) => onChangeHandler(value !== null ? Util.dateFormat(value, 'DD.MM.YYYY') : '') }
          />
        )}
      </Labeled>
    )
  }

  return (
    <React.Fragment>
      <Labeled 
        key = { field.code }
        variant = { lookAndFeel.labeledVariant }
        label = { field.title }
        isRequired = { !field.isOptional }
      >
        <InputTextbox
          variant = { lookAndFeel.textboxVariant }
          value = { fieldValue ?? '' }
          isError = { fieldError !== undefined }
          hint = { fieldError ?? '' }
          readOnly = { !field.refer.isCanEditHand }
          placeholder = { field.hint ?? '' }
          maxLength = { field.size }
          customIcon = { <ArrowDownVector /> }
          onChange = { onChangeHandler }
          onCustomIconTap = { () => setReferOpened(true) }
          onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCustomFieldErrorFixed(field.code)) }
        />
      </Labeled>
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { referItems }
        isOpened = { referOpened }
        isSearchable = { field.refer.isFind }
        label = { field.title }
        selectedId = { fieldValue ? `${fieldValue}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onChangeValueHandler }
      />
    </React.Fragment>
  )
}

const CustomFields: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  const fields = [...account.fields].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <React.Fragment>
      {fields.map((field, index) => (
        <CustomField key = { index } field = { field } lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
      ))}
    </React.Fragment>
  )
}

const IsMarriageShare: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const isMarriageShareExpanded = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsMarriageShareExpanded);
  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  const onMariageExpanedChanged = (checked: boolean) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedIsMarriageShareChanged(checked));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isEntryAccounting || account.role === AccountRole.Contractor)
  {
    return null;
  }

  return (
    <FormRowElement lookAndFeel = { lookAndFeel }>
      <Typography variant = { lookAndFeel.topoSwitchLabelTypo }>Рассчитать долю брака</Typography>
      <Switch
        variant = { lookAndFeel.topoSwitchVariant }
        value = { isMarriageShareExpanded }
        onChange = { onMariageExpanedChanged }
      />
    </FormRowElement>
  )
}

const WeightBeforeProcessing: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const weight = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedWeightBeforeProcessing);
  const isMarriageShareExpanded = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsMarriageShareExpanded);
  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isMarriageShareExpanded)
  {
    return null;
  }

  return (
    <Labeled
      variant = { lookAndFeel.labeledVariant }
      label = 'Вес до переработки'
    >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${weight ?? ''}` }
        placeholder = 'До переработки'
        valueTransformer = { Util.selectDigitsAndDotFromString3 }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedWeightBeforeProcessingChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
      />
    </Labeled>
  )
}

const WeightAfterProcessing: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const weight = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedWeightAfterProcessing);
  const weightError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedWeightAfterProcessingError);
  const isMarriageShareExpanded = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsMarriageShareExpanded);
  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isMarriageShareExpanded)
  {
    return null;
  }

  return (
    <Labeled
      variant = { lookAndFeel.labeledVariant }
      label = 'Вес годного после переработки'
    >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${weight ?? ''}` }
        isError = { weightError !== '' }
        hint = { weightError }
        placeholder = 'После переработки'
        valueTransformer = { Util.selectDigitsAndDotFromString3 }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedWeightAfterProcessingChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
      />
    </Labeled>
  )
}

const MarriageShare: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const marriageShare = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedMarriageShare);
  const isMarriageShareExpanded = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsMarriageShareExpanded);
  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isMarriageShareExpanded)
  {
    return null;
  }

  return (
    <MarriageShareContainer lookAndFeel = { lookAndFeel }>
      <span>Доля брака</span>
      <span>{ `${marriageShare ?? 0}%` }</span>
    </MarriageShareContainer>
  )
}

const Weight: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const inspectionAsyncs = storeApi.inspection.edit.async;
  const inspectionActions = storeApi.inspection.edit.actions;
  const authSelectors = storeApi.auth.common.selectors;

  const unitsAll = useAppSelector(inspectionSelectors.selectGeneralUnitRefer);
  const weight = useAppSelector(inspectionSelectors.selectPieceEditedWeight);
  const weightError = useAppSelector(inspectionSelectors.selectPieceEditedWeightError);
  const unit = useAppSelector(inspectionSelectors.selectPieceEditedUnit);
  const unitElement = unitsAll.find((item) => item.id === unit?.id) ?? null;
  const defectGuid = useAppSelector(inspectionSelectors.selectDefectExpandedGuid);
  const defectId = useAppSelector((state) => inspectionSelectors.selectDefectDefectId(state, defectGuid)) ?? 0;
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(authSelectors.selectAccount)!;

  const productTypeKolpinoId = useAppSelector(inspectionSelectors.selectPieceEditedProductTypeKolpinoId);
  const isKolpino = useAppSelector(authSelectors.selectIsKolpino);

  const { MECHANICAL_ENGINEERING_PART, PROCESSED_SHEET } = ProductTypeKolpino;
  const isDisabledUnit = isKolpino && productTypeKolpinoId !== null && [MECHANICAL_ENGINEERING_PART, PROCESSED_SHEET].includes(productTypeKolpinoId);

  const unitDetail = unitElement === null ? null : unitElement.details.find((item) => item.isEntryAccounting === isEntryAccounting) ?? null;

  const [referOpened, setReferOpened] = React.useState<boolean>(false);
  const [warningOpened, setWarningOpened] = React.useState<boolean>(false);
  const [warningShowed, setWarningShowed] = React.useState<boolean>(false);
  const [warningMessage, setWarningMessage] = React.useState<string>('');
  const [defectCalcShowed, setDefectCalcShowed] = React.useState<boolean>(false);

  const items = unitsAll
    .filter((item) => item.isActual)
    .filter((item) => isEntryAccounting || item.id !== 35)
    .map((item) => ({
      id: `${item.id}`,
      label: item.title
    }));

  React.useEffect(() => {
    if (weight.endsWith('.'))
    {
      if (!warningShowed && unit?.id === 1)
      {
        setWarningMessage('Указывать вес нетто в кг.');
        setWarningOpened(true);
      }
    }
    else
    {
      if (weight.length > 0 && [19,34].includes(defectId) && ((unit?.id === 1 && parseFloat(weight) > 3000) || (unit?.id === 2 && parseFloat(weight) > 3)))
      {
        setWarningMessage('При выборе дефекта «Недостача» или «Излишки» необходимо указывать разницу между фактическим весом и весом по документу поставки');
        setWarningOpened(true);
        dispatch(inspectionActions.pieceEditedWeightChanged(''));
        setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
      }
    }
    
  }, [warningShowed, weight, unit, defectId, dispatch]);

  const onItemSelectedHandler = (item: ReferSelectorItem) => {
    dispatch(inspectionActions.pieceEditedWeightUnitChanged(parseInt(item.id, 10)));
    setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onWarningCloseHandler = () => {
    setWarningOpened(false);
    setWarningShowed(true);
  }

  const onDefectCalcAcceptHandler = (value: string, tab: 'weight' | 'weightpipe' | 'area') => {
    setDefectCalcShowed(false);
    dispatch(inspectionActions.pieceEditedWeightChanged(value));
    dispatch(inspectionActions.pieceEditedWeightUnitChanged(['weight', 'weightpipe'].includes(tab) ? 1 : 35));
    setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  return (
    <React.Fragment>
      <Labeled
        variant = { lookAndFeel.labeledVariant }
        label = { unit?.fieldTitle ?? 'Вес' }
        isRequired = { !isEntryAccounting && account.role !== AccountRole.Contractor }
      >
        <WeightColumn lookAndFeel = { lookAndFeel }>
          {[19, 34, 43].includes(defectId) && (
            <Typography variant='blue2w400s12lh14'>
              Указать <Typography variant='redw400s12lh14'>разницу</Typography> между фактическим весом и весом по документу/бирке.
            </Typography>
          )}
          <WeightContainer lookAndFeel = { lookAndFeel }>
            <InputTextbox
              variant = { lookAndFeel.textboxVariant }
              value = { `${weight ?? ''}` }
              isError = { weightError !== '' }
              hint = { weightError }
              placeholder = { unitDetail?.fieldHint ?? '' }
              valueTransformer = { 
                (unitElement?.isInteger) ? 
                Util.selectDigitsFromString
                : 
                (
                  unitElement?.id === 35 ?
                  (value: string) => Util.selectDigitsAndDotFromStringN_M(value, 8, 2)
                  :
                  (value: string) => Util.selectDigitsAndDotFromStringN_M(value, 6, 3)
                )
              }
              onChange = { (value) => {
                dispatch(inspectionActions.pieceEditedWeightChanged(value));
                setTimeout(() => dispatch(inspectionAsyncs.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
              }}
              onFocus = { () => dispatch(inspectionActions.pieceEditedWeightErrorFixed()) }
              customIcon = { `${weight ?? ''}`.trim() === '' ? <CalculatorVector /> : undefined }
              onCustomIconTap = { () => setDefectCalcShowed(true) }
            />
            <InputTextbox
              variant = { lookAndFeel.textboxVariant }
              value = { unit?.title ?? '' }
              readOnly
              isDisabled = { isDisabledUnit }
              onChange = { (value: string) => {  } }
              placeholder = ''
              customIcon = { <ArrowDownVector /> }
              onCustomIconTap = { () => setReferOpened(true) }
            />
          </WeightContainer>
        </WeightColumn>
      </Labeled>
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = 'Единица измерения'
        selectedId = { unit ? `${unit.id}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
      <TwoActionDialog
        variant = { lookAndFeel.weightInputWarningDialogVariant }
        opened = { warningOpened }
        caption = 'Внимание!'
        message = { warningMessage }
        withoutCancel
        isDanger
        onAction = { onWarningCloseHandler }
      />
      <DefectCalcDialog
        variant = { lookAndFeel.defectCalcDialogVariant }
        opened = { defectCalcShowed }
        isAreaAcceptable = { isEntryAccounting }
        onAccept = { onDefectCalcAcceptHandler }
        onClose = { () => setDefectCalcShowed(false) }
      />
    </React.Fragment>
  )
}

const Note: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const note = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedNote);
  const noteError = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedNoteError);

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = 'Детальное описание по позиции (прочие комментарии)'>
      <InputMultiline
        variant = { lookAndFeel.multilineVariant }
        value = { note ?? '' }
        isError = { noteError !== '' }
        hint = { noteError }
        maxLength = { 2000 }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedNoteChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
        onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedNoteErrorFixed()) }
      />
    </Labeled>
  )
}

const Photo: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const alert = useAlert();
  const [typeForAdd, setTypeForAdd] = React.useState<types.inspection.PieceFileType>(TYPE_GENERAL);
  const [guidForDelete, setGuidForDelete] = React.useState<string>('');
  const [confirmDeleteOpened, setConfirmDeleteOpened] = React.useState<boolean>(false);
  const [warningAppendOpened, setWarningAppendOpened] = React.useState<boolean>(false);
  const [warningAppendMessage, setWarningAppendMessage] = React.useState<string>('');

  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const files = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedFiles);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  const defectRefer = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralDefectRefer);
  const defectGuid = useAppSelector(storeApi.inspection.edit.selectors.selectDefectExpandedGuid);
  const defectType = useAppSelector((store) => storeApi.inspection.edit.selectors.selectDefectType(store, defectGuid));
  const defectId = useAppSelector((store) => storeApi.inspection.edit.selectors.selectDefectDefectId(store, defectGuid));
  const defectReferItem = defectRefer.find((item) => item.id === defectId) ?? null;
  const noAttachCfg = defectReferItem?.configs?.find((cfg) => cfg.code === "NO_ATTACH")?.value ?? "0";
  const isDirtyWagons = defectType === DefectType.DIRTY_WAGONS;
  const isTerm = defectType === DefectType.TERM;

  const pieceEditedGuid = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedGuid)!;
  const cvDuplicates = useAppSelector(storeApi.inspection.edit.selectors.selectPieceCVCheckFilesDuplicates)[pieceEditedGuid] ?? [];
  const cvBlur = useAppSelector(storeApi.inspection.edit.selectors.selectPieceCVCheckFilesBlur)[pieceEditedGuid] ?? [];

  let isRequired = !isEntryAccounting && noAttachCfg === "0";
  let title = 'Фотографии дефекта';

  if (isDirtyWagons)
  {
    title = 'Вложения';
  }

  if (isTerm)
  {
    isRequired = false;
    title = 'Вложения';
  }
  
  const photoCountAll = parseInt(account.configs.find((config) => config.code === 'CNT_PHOTO')?.value ?? '15', 10);
  const docCountAll = parseInt(account.configs.find((config) => config.code === 'CNT_PDF')?.value ?? '3', 10);
  const general = files.find((file) => file.type === TYPE_GENERAL && file.mode !== MODE_DEL) ?? null;
  const isGeneralExists = general !== null;
  const photos = files.filter((file) => file.type === TYPE_PHOTO && file.mode !== MODE_DEL);
  const photoCountAllow = photoCountAll - (isGeneralExists ? 1 : 0) - photos.length;
  const docs = files.filter((file) => [TYPE_PDF].includes(file.type) && file.mode !== MODE_DEL);
  const docCountAllow = docCountAll - docs.length;

  const onPhotosSelectedHandler = async (list: FileList) => {
    const listAsArray = Array.from(list);
    let counter = photoCountAllow;
    let type = typeForAdd;
    let warningMessage = '';

    if (type === TYPE_PHOTO && !isGeneralExists)
    {
      counter -= 1;
    }

    if (isGeneralExists)
    {
      if (list.length > counter)
      {
        warningMessage = `Вы выбрали ${list.length} фото, можно добавить только ${counter}. Лишние фотографии не добавлены`;
      }
    }
    else
    {
      if (type === TYPE_GENERAL)
      {
        if (list.length > counter)
        {
          warningMessage = `Вы выбрали ${list.length} фото, можно добавить только ${counter}. Лишние фотографии не добавлены`;
        }
      }
      else
      {
        if (list.length > counter)
        {
          warningMessage = `Вы выбрали ${list.length} фото, можно добавить только ${counter}. Одно фото нужно обязательно загрузить через плитку Общий вид. Лишние фотографии не добавлены`;
        }
      }
    }

    if (warningMessage !== '')
    {
      setWarningAppendMessage(warningMessage);
      setWarningAppendOpened(true);
    }

    let generalList: File[] = [];
    let photoList: File[] = [];

    for (const file of listAsArray)
    {
      if (counter === 0)
      {
        break;
      }

      if (type === TYPE_GENERAL)
      {
        generalList.push(file);
        type = TYPE_PHOTO;
      }
      else
      {
        photoList.push(file);
      }

      counter -= 1;
    }

    const imageProcessing = async (files: File[], imageType: types.inspection.PieceFileType): Promise<void> => {
      if (files.length > 0)
      {
        let file = files[0];
        const fileTypeByExt = Util.checkFileTypeByExt(file.name);

        if (!['JPG', 'JFIF', 'BMP', 'PNG', 'WEBP', 'HEIC', 'TIF'].includes(fileTypeByExt))
        {
          alert.error(`Файл ${file.name} не является изображением`);
          return imageProcessing(files.slice(1), imageType);
        }

        const fileTypeByHeader = await Util.checkFileTypeByHeader(file);

        if (!['JPG', 'JFIF', 'BMP', 'PNG', 'WEBP', 'HEIC', 'TIF'].includes(fileTypeByHeader))
        {
          alert.error(`Файл ${file.name} не является изображением`);
          return imageProcessing(files.slice(1), imageType);
        }

        if (fileTypeByHeader === "HEIC") {
          alert.info('Конвертация HEIC в JPG занимает некоторое время, пожалуйста ждите');

          const fileJpg = await heicTo({
            blob: file,
            type: "image/jpeg",
            quality: 1,
          });

          file = new File(
            [fileJpg],
            `${file.name.substring(0, file.name.lastIndexOf("."))}.jpg`,
            {
              type: fileJpg.type,
              lastModified: Date.now(),
            }
          );
        }

        const guid = uuidv4();
        const isTIF = fileTypeByHeader === 'TIF';
        const resizedFile = isTIF ? file : (await Util.resizeIfImage(file, Constants.PIECE_IMAGE_BIGGEST_SIZE));
        const dataUrlResult = await Util.imageToDataURL(resizedFile);
        const binaryStr = await Util.fileToBinaryString(resizedFile);

        const fileName = Util.buildPieceAttachmentName(imageType, file.name);

        if (dataUrlResult.ok)
        {
          dispatch(storeApi.inspection.edit.actions.generalOpStatusChanged(AsyncOpStatus.BUSY));
          dispatch(storeApi.inspection.edit.actions.generalOpStatusLabelChanged(`Отправка файла ${file.name} на сервер`));
          try
          {
            const data = new FormData();

            data.append('guid', guid);
            data.append('ab_file_source', resizedFile);
            await api.postInspectionFileByGuid(data);

            dispatch(storeApi.inspection.edit.actions.generalOpStatusChanged(AsyncOpStatus.SUCCESS));

            dispatch(storeApi.inspection.edit.actions.pieceEditedPhotoAdded({
              guid,
              mode: MODE_NEW,
              name: fileName,
              type: imageType,
              __dataUrl: dataUrlResult.result,
              __binaryStr: binaryStr,
              __mime: isTIF ? 'image/tiff' : 'image/jpeg',
              __name: fileName
            }));
          }
          catch (error)
          {
            dispatch(storeApi.inspection.edit.actions.generalOpStatusChanged(AsyncOpStatus.ERROR));
            alert.error(`Файл ${file.name} не удалось сохранить на сервере`);
          }
        }
        else
        {
          alert.error(`Файл ${file.name} не является изображением`);
        }

        return imageProcessing(files.slice(1), imageType);
      }
    }

    await imageProcessing(generalList, TYPE_GENERAL);

    await imageProcessing(photoList, TYPE_PHOTO);

    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onDocumentSelectedHandler = async (list: FileList) => {
    const listAsArray = Array.from(list);
    let warningMessage = '';

    if (list.length > docCountAllow)
    {
      warningMessage = `Вы выбрали ${list.length} документов, можно добавить только ${docCountAllow}. Лишние документы не добавлены`;
    }

    if (warningMessage !== '')
    {
      setWarningAppendMessage(warningMessage);
      setWarningAppendOpened(true);
    }

    const docList = listAsArray.length > docCountAllow ? listAsArray.slice(0, docCountAllow) : listAsArray;

    const docProcessing = async (files: File[]): Promise<void> => {
      if (files.length > 0)
      {
        const file = files[0];
        const fileTypeByExt = Util.checkFileTypeByExt(file.name);

        if (!['PDF', 'XLSX'].includes(fileTypeByExt))
        {
          alert.error(`Файл ${file.name} не является PDF или XLSX документом`);
          return docProcessing(files.slice(1));
        }

        const fileTypeByHeader = await Util.checkFileTypeByHeader(file);

        if (!['PDF', 'XLSX'].includes(fileTypeByHeader))
        {
          alert.error(`Файл ${file.name} не является PDF или XLSX документом`);
          return docProcessing(files.slice(1));
        }

        if ((file.size / Math.pow(1024, 2)) > Constants.PIECE_DOC_BIGGEST_SIZE_MB)
        {
          alert.error(`Размер файла ${file.name} превышает допустимый размер прикрепляемого файла в ${Constants.PIECE_DOC_BIGGEST_SIZE_MB} Мбайт`);
          return docProcessing(files.slice(1));
        }

        const guid = uuidv4();
        const binaryStr = await Util.fileToBinaryString(file);
        const dataUrlResult = await Util.fileToDataURL(file);

        let fileName = Util.buildPieceAttachmentName(TYPE_PDF, file.name);

        if (dataUrlResult.ok)
        {
          dispatch(storeApi.inspection.edit.actions.pieceEditedPhotoAdded({
            guid,
            mode: MODE_NEW,
            name: fileName,
            type: TYPE_PDF,
            __dataUrl: dataUrlResult.result,
            __binaryStr: binaryStr,
            __mime: file.type,
            __name: fileName
          }));
        }
        else
        {
          alert.error(`Произошла ошибка при обработке файла`);
        }

        return docProcessing(files.slice(1));
      }
    }

    await docProcessing(docList);

    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onDragFiles = (attachmentType: types.inspection.PieceFileType, list: FileList) => {
    setTypeForAdd(attachmentType);
    setTimeout(
      () => {
        switch (attachmentType)
        {
          case TYPE_GENERAL:
          case TYPE_PHOTO:
            onPhotosSelectedHandler(list);
            break;
          case TYPE_PDF:
            onDocumentSelectedHandler(list);
            break;
        }
      },
      0
    );
  }

  const onAddHandler = (attachmentType: types.inspection.PieceFileType) => {
    setTypeForAdd(attachmentType);
    setTimeout(() => document.getElementById(`piece-${attachmentType === TYPE_PDF ? 'doc' : 'photo'}-selector`)?.click(), 0);
  }

  const onDeleteHandler = (guid: string) => {
    setConfirmDeleteOpened(true);
    setGuidForDelete(guid);
  }

  const onCancelDeletePhotoHandler = () => {
    setConfirmDeleteOpened(false);
  }

  const onAcceptDeletePhotoHandler = () => {
    setConfirmDeleteOpened(false);
    dispatch(storeApi.inspection.edit.actions.pieceEditedPhotoDeleted(guidForDelete));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  const onAcceptWarningAppendHandler = () => {
    setWarningAppendOpened(false);
  }

  const onCVDuplicateClickHandler = () => {
    alert.error("Фото является дублем");
  }

  const onCVBlurClickHandler = () => {
    alert.error("Фото плохого качества");
  }

  return (
    <Labeled variant = { lookAndFeel.labeledVariant } label = { title } isRequired = { isRequired }>
      <PhotoContainer lookAndFeel = { lookAndFeel }>
        {(cvDuplicates.length > 0 || cvBlur.length > 0) && (
          <PhotoCVLegend lookAndFeel = { lookAndFeel }>
            {cvDuplicates.length > 0 && (
              <PhotoCVLegendItem lookAndFeel = { lookAndFeel }>
                <CVDuplicateVector />
                <span>Дубль</span>
              </PhotoCVLegendItem>
            )}
            {cvBlur.length > 0 && (
              <PhotoCVLegendItem lookAndFeel = { lookAndFeel }>
                <CVBlurVector />
                <span>Плохое качество фото</span>
              </PhotoCVLegendItem>
            )}
          </PhotoCVLegend>
        )}
        <PhotoList lookAndFeel = { lookAndFeel }>
          <PhotoProvider >
            {!isGeneralExists && (
              <AttachmentAdd
                variant = { lookAndFeel.attachmentAddVariant }
                attachmentType = { TYPE_GENERAL }
                label = 'Общий вид'
                isRequired = { isRequired }
                onTap = { onAddHandler }
                onDragFiles = { (list: FileList) => onDragFiles(TYPE_GENERAL, list) }
              />
            )}
            {isGeneralExists && (
              <AttachmentPhoto
                variant = { lookAndFeel.attachmentPhotoVariant }
                isAllowDelete
                isCVBlur = { cvBlur.includes(general.guid) }
                isCVDuplicate = { cvDuplicates.includes(general.guid) }
                photo = { general }
                onDelete = { onDeleteHandler }
                onCVDuplicateClick = { onCVDuplicateClickHandler }
                onCVBlurClick = { onCVBlurClickHandler }
              />
            )}
            {photos.map((photo) => (
              <AttachmentPhoto
                key = { photo.guid }
                variant = { lookAndFeel.attachmentPhotoVariant }
                isAllowDelete
                isCVBlur = { cvBlur.includes(photo.guid) }
                isCVDuplicate = { cvDuplicates.includes(photo.guid) }
                photo = { photo }
                onDelete = { onDeleteHandler }
                onCVDuplicateClick = { onCVDuplicateClickHandler }
                onCVBlurClick = { onCVBlurClickHandler }
              />
            ))}
            {docs.map((doc) => (
              <AttachmentDOC
                key = { doc.guid }
                variant = { lookAndFeel.attachmentPhotoVariant }
                isAllowDelete
                doc = { doc }
                source = 'piece'
                onDelete = { onDeleteHandler }
              />
            ))}
            {(isGeneralExists && photoCountAllow > 0) && (
              <AttachmentAdd
                variant = { lookAndFeel.attachmentAddVariant }
                attachmentType = { TYPE_PHOTO }
                label = 'Доп. фото'
                allowCount = { photoCountAllow - ( isGeneralExists ? 0 : 1 ) }
                onTap = { onAddHandler }
                onDragFiles = { (list: FileList) => onDragFiles(TYPE_PHOTO, list) }
              />
            )}
            {(isGeneralExists && docCountAllow > 0) && (
              <AttachmentAdd
                variant = { lookAndFeel.attachmentAddVariant }
                attachmentType = { TYPE_PDF }
                label = 'Доп. файл'
                allowCount = { docCountAllow }
                onTap = { onAddHandler }
                onDragFiles = { (list: FileList) => onDragFiles(TYPE_PDF, list) }
              />
            )}
            </PhotoProvider>
        </PhotoList>
      </PhotoContainer>
      <input
        id = 'piece-photo-selector' 
        type = 'file' 
        accept = '.png,.bmp,.jpg,.jpeg,.jfif,.webp,.heic,.tif,.tiff'
        multiple
        onChange = { (e) => e.target.files !== null && onPhotosSelectedHandler(e.target.files) } 
        onClick = { () => (document.getElementById('piece-photo-selector') as HTMLInputElement).value = '' }
        style = { { display: 'none' } }
      />
      <input
        id = 'piece-doc-selector' 
        type = 'file' 
        accept = '.pdf,.xlsx'
        multiple
        onChange = { (e) => e.target.files !== null && onDocumentSelectedHandler(e.target.files) }
        onClick = { () => (document.getElementById('piece-doc-selector') as HTMLInputElement).value = '' }
        style = { { display: 'none' } }
      />
      <TwoActionDialog 
        variant = { lookAndFeel.deletePhotoDialogVariant } 
        opened = { confirmDeleteOpened }
        caption = 'Удалить вложение?'
        onCancel = { onCancelDeletePhotoHandler }
        onAction = { onAcceptDeletePhotoHandler }
      />
      <TwoActionDialog 
        variant = { lookAndFeel.deletePhotoDialogVariant } 
        opened = { warningAppendOpened }
        caption = 'Внимание'
        message = { warningAppendMessage }
        withoutCancel
        actionLabel = 'Ok'
        isDanger
        onAction = { onAcceptWarningAppendHandler }
      />
    </Labeled>
  )
}

const IsTopography: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);

  const account = useAppSelector(authSelectors.selectAccount)!;

  const onTopoExpanedChanged = (checked: boolean) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedIsTopographyChanged(checked));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isEntryAccounting || account.role === AccountRole.Contractor)
  {
    return null;
  }

  return (
    <FormRowElement lookAndFeel = { lookAndFeel }>
      <Typography variant = { lookAndFeel.topoSwitchLabelTypo }>Топография дефекта</Typography>
      <Switch
        variant = { lookAndFeel.topoSwitchVariant }
        value = { isTopographyExpanded }
        onChange = { onTopoExpanedChanged }
      />
    </FormRowElement>
  )
}

const TopographyNote: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const isTopographyExpanded = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(storeApi.inspection.edit.selectors.selectGeneralIsEntryAccounting);
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <Typography variant = { lookAndFeel.topoNoteTypo }>
      Топографию дефекта заполнить ниже или сделать фото с рулеткой
    </Typography>
  )
}

const TopographySize: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const size = useAppSelector(inspectionSelectors.selectPieceEditedTopoSize);
  const sizeError = useAppSelector(inspectionSelectors.selectPieceEditedTopoSizeError);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <Labeled
      variant = { lookAndFeel.labeledVariant }
      label = 'Размер дефекта'
    >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${size ?? ''}` }
        isError = { sizeError !== '' }
        hint = { sizeError }
        placeholder = 'мм'
        valueTransformer = { Util.selectDigitsAndDotFromString3 }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedTopoSizeChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
        onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedTopoSizeErrorFixed()) }
      />
    </Labeled>
  )
}

const TopographySizeId: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const sizeId = useAppSelector(inspectionSelectors.selectPieceEditedTopoSizeId);
  const sizeTitle = useAppSelector(inspectionSelectors.selectPieceEditedTopoSizeTitle);
  const topoRefer = useAppSelector(inspectionSelectors.selectGeneralTopographyRefer);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  const [referOpened, setReferOpened] = React.useState<boolean>(false);

  const items = topoRefer.filter((item) => item.isActual && item.typeTopography === 'size').map((item) => ({
    id: `${item.id}`,
    label: item.title
  }))

  const onItemSelectedHandler = (item: ReferSelectorItem) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedTopoSizeIdChanged(parseInt(item.id, 10)));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <React.Fragment>
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { sizeTitle ?? '' }
        readOnly
        onChange = { (value: string) => {  } }
        placeholder = ''
        customIcon = { <ArrowDownVector /> }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onCustomIconTap = { () => setReferOpened(true) }
      />
      <Hr lookAndFeel = { lookAndFeel } />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = 'Размер дефекта'
        selectedId = { sizeId ? `${sizeId}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </React.Fragment>
  )
}

const TopographyStep: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const step = useAppSelector(inspectionSelectors.selectPieceEditedTopoStep);
  const stepError = useAppSelector(inspectionSelectors.selectPieceEditedTopoStepError);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <Labeled
      variant = { lookAndFeel.labeledVariant }
      label = 'Шаг дефекта'
    >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${step ?? ''}` }
        isError = { stepError !== '' }
        hint = { stepError }
        placeholder = 'мм'
        valueTransformer = { Util.selectDigitsAndDotFromString3 }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedTopoStepChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
        onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedTopoStepErrorFixed()) }
      />
    </Labeled>
  )
}

const TopographyStepId: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const stepTitle = useAppSelector(inspectionSelectors.selectPieceEditedTopoStepTitle);
  const stepId = useAppSelector(inspectionSelectors.selectPieceEditedTopoStepId);
  const topoRefer = useAppSelector(inspectionSelectors.selectGeneralTopographyRefer);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  const [referOpened, setReferOpened] = React.useState<boolean>(false);

  const items = topoRefer.filter((item) => item.isActual && item.typeTopography === 'step').map((item) => ({
    id: `${item.id}`,
    label: item.title
  }))

  const onItemSelectedHandler = (item: ReferSelectorItem) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedTopoStepIdChanged(parseInt(item.id, 10)));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <React.Fragment>
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { stepTitle ?? '' }
        readOnly
        onChange = { (value: string) => {  } }
        placeholder = ''
        customIcon = { <ArrowDownVector /> }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onCustomIconTap = { () => setReferOpened(true) }
      />
      <Hr lookAndFeel = { lookAndFeel } />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = 'Шаг дефекта'
        selectedId = { stepId ? `${stepId}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </React.Fragment>
  )
}

const TopographyDistance: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const distance = useAppSelector(inspectionSelectors.selectPieceEditedTopoDistance);
  const distanceError = useAppSelector(inspectionSelectors.selectPieceEditedTopoDistanceError);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <Labeled
      variant = { lookAndFeel.labeledVariant }
      label = 'Расстояние от кромки'
    >
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { `${distance ?? ''}` }
        isError = { distanceError !== '' }
        hint = { distanceError }
        placeholder = 'мм'
        valueTransformer = { Util.selectDigitsAndDotFromString3 }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onChange = { (value) => {
          dispatch(storeApi.inspection.edit.actions.pieceEditedTopoDistanceChanged(value));
          setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
        }}
        onFocus = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedTopoDistanceErrorFixed()) }
      />
    </Labeled>
  )
}

const TopographyDistanceId: React.FC<PieceEditFormElement> = ({ lookAndFeel, dispatch }) => {
  const inspectionSelectors = storeApi.inspection.edit.selectors;
  const authSelectors = storeApi.auth.common.selectors;

  const distanceId = useAppSelector(inspectionSelectors.selectPieceEditedTopoDistanceId);
  const distanceTitle = useAppSelector(inspectionSelectors.selectPieceEditedTopoDistanceTitle);
  const topoRefer = useAppSelector(inspectionSelectors.selectGeneralTopographyRefer);
  const isTopographyExpanded = useAppSelector(inspectionSelectors.selectPieceEditedIsTopographyExpanded);
  const isEntryAccounting = useAppSelector(inspectionSelectors.selectGeneralIsEntryAccounting);
  const isChangeToComplaint = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaint);
  const isChangeToComplaintFinance = useAppSelector(inspectionSelectors.selectGeneralIsChangeToComplaintFinance);
  const inspectionState = useAppSelector(inspectionSelectors.selectGeneralInspectionState);

  const account = useAppSelector(authSelectors.selectAccount)!;

  const [referOpened, setReferOpened] = React.useState<boolean>(false);

  const items = topoRefer.filter((item) => item.isActual && item.typeTopography === 'distance').map((item) => ({
    id: `${item.id}`,
    label: item.title
  }))

  const onItemSelectedHandler = (item: ReferSelectorItem) => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedTopoDistanceIdChanged(parseInt(item.id, 10)));
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE)), 200);
  }

  if (isEntryAccounting || account.role === AccountRole.Contractor || !isTopographyExpanded)
  {
    return null;
  }

  return (
    <React.Fragment>
      <InputTextbox
        variant = { lookAndFeel.textboxVariant }
        value = { distanceTitle ?? '' }
        readOnly
        onChange = { (value: string) => {  } }
        placeholder = ''
        customIcon = { <ArrowDownVector /> }
        isDisabled = {
          inspectionState === types.inspection.InspectionState.EDIT
          &&
          !(isChangeToComplaint || isChangeToComplaintFinance)
        }
        onCustomIconTap = { () => setReferOpened(true) }
      />
      <ReferSelector
        variant = { lookAndFeel.referSelectorVariant }
        referItemsList = { items }
        isOpened = { referOpened }
        label = 'Расстояние от кромки'
        selectedId = { distanceId ? `${distanceId}` : null }
        onClose = { () => setReferOpened(false) }
        onSelect = { onItemSelectedHandler }
      />
    </React.Fragment>
  )
}


type Props = {
  variant: PieceEditVariants;
}
export const PieceEdit: React.FC<Props> = ({
  variant,
}) => {
  const lookAndFeel = pieceedit_variants.get(variant)!;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [submitErrorOpened, setSubmitErrorOpened] = React.useState<boolean>(false);
  const [submitError, setSubmitError] = React.useState<string>('');
  const [closeConfirmOpened, setCloseConfirmOpened] = React.useState<boolean>(false);
  const [forceBack, setForceBack] = React.useState<boolean>(false);

  const isOpened = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditOpened);
  const isDouble = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsDouble);
  const isPiece = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsPiece);
  const isLoadedFromQMET = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedIsLoadedFromQMET);
  const pieceGuid = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedGuid) ?? '';
  const dialogTitle = useAppSelector((store) => storeApi.inspection.edit.selectors.selectPieceEditDialogTitle(store, pieceGuid));
  const acceptText = useAppSelector((store) => storeApi.inspection.edit.selectors.selectPieceEditDialogAcceptText(store, pieceGuid));
  const defectGuid = useAppSelector(storeApi.inspection.edit.selectors.selectDefectExpandedGuid);
  const defectType = useAppSelector((store) => storeApi.inspection.edit.selectors.selectDefectDefectType(store, defectGuid));
  const defectId = useAppSelector((state) => storeApi.inspection.edit.selectors.selectDefectDefectId(state, defectGuid)) ?? 0;
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;
  const isKolpino = useAppSelector(storeApi.auth.common.selectors.selectIsKolpino);

  const isQualityOrService = [null, DefectType.QUALITY, DefectType.SERVICE].includes(defectType);
  const isDirtyWagons = defectType === DefectType.DIRTY_WAGONS;
  const isTerm = defectType === DefectType.TERM;

  React.useEffect(() => {
    if (isOpened)
    {
      navigate('', { state: { isPopup: true } });
    }
  }, [isOpened, navigate])

  React.useEffect(() => {
    const backListener = (ev: PopStateEvent) => {
      ev.preventDefault();
      if (forceBack)
      {
        dispatch(storeApi.inspection.edit.actions.pieceEditClosed());
      }
      else
      {
        dispatch(storeApi.inspection.edit.async.closePieceAsync())
          .unwrap()
          .then((result) => {
            if (result.hasChanges)
            {
              setCloseConfirmOpened(true);
            }
            else
            {
              dispatch(storeApi.inspection.edit.actions.pieceEditClosed());
            }
          })
      }
    }
    window.addEventListener('popstate', backListener);

    return () => {
      window.removeEventListener('popstate', backListener);
    }
  }, [dispatch, forceBack]);

  const goBack = (force: boolean) => {
    setForceBack(force);
    setTimeout(() => navigate(-1), 100);
  }

  const onActionSubmitErrorHandler = () => {
    if (submitError === 'Изменения отсутствуют')
    {
      goBack(true);
    }
    else
    {
      dispatch(storeApi.inspection.edit.actions.pieceEditedIsDoubleChanged(false));
    }
    setSubmitErrorOpened(false);
    setSubmitError('');
  }

  const onRequestSaveAcceptHandler = () => {
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_TRUE_APPLY)), 200);
    setCloseConfirmOpened(false);
    dispatch(storeApi.inspection.edit.actions.pieceEditClosed());
  }

  const onRequestSaveCancelHandler = () => {
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_FALSE)), 200);
    setCloseConfirmOpened(false);
    dispatch(storeApi.inspection.edit.actions.pieceEditClosed());
  }

  const onSubmitHandler = () => {
    dispatch(storeApi.inspection.edit.async.commonChecksBeforeAddPieceAsync())
      .unwrap()
      .then((commonResult) => {
        if (!commonResult.pieceEditedIsDouble)
        {
          dispatch(storeApi.inspection.edit.async.extdoublesChecksBeforeAddPieceAsync())
            .unwrap()
            .then((extdoublesResult) => {
              if (extdoublesResult.externalDoubles.length === 0)
              {
                dispatch(storeApi.inspection.edit.async.cvChecksBeforeAddPieceAsync())
                  .unwrap()
                  .then((cvResult) => {
                    if (cvResult.cvCheckFilesResultGroup === null && cvResult.cvCheckFilesResultSingle.length === 0)
                    {
                      dispatch(storeApi.inspection.edit.actions.pieceEditedSaveChanges());
                      setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_FALSE)), 200);
                    }
                  })
              }
            })
        }
      })
      .catch((error) => {
        setSubmitError(error);
        setSubmitErrorOpened(true);
      });
  }

  return (
    <Drawer
      anchor = 'bottom'
      open = { isOpened }
      onClose = { () => goBack(false) }
    >
      <Container lookAndFeel = { lookAndFeel }>
        <HeaderContainer lookAndFeel = { lookAndFeel }>
          <IconButton
            variant = { lookAndFeel.headerIconButtonVariant }
            isTapAllowed
            onTap = { () => goBack(false) }
          >
            <ArrowBackVector />
          </IconButton>
          <Typography variant = { lookAndFeel.headerTypographyVariant }>
            { dialogTitle }
          </Typography>
          <Grow size = { 2 } />
          <IconButton
            variant = { lookAndFeel.headerIconButtonVariant }
            isTapAllowed
            onTap = { () => goBack(false) }
          >
            <CloseOutlineVectorBig />
          </IconButton>
        </HeaderContainer>
        <FormContainer lookAndFeel = { lookAndFeel }>
          <Typography variant = 'blackw600s18lh24'>Информация</Typography>
          {[15, 52].includes(defectId) && (
            <WarningAlert lookAndFeel = { lookAndFeel }>
              <CircleWarningVector />
              <Typography variant='blue2w400s15lh20'>
                Указать данные позиии по документу. В описании добавить данные по фактической позиции (фото бирки).
              </Typography>
            </WarningAlert>
          )}
          {isQualityOrService && (
            <React.Fragment>
              <InputUEModeSwitcher lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              {!isPiece && (
                <React.Fragment>
                  <QmetId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  <ProductType lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  {isLoadedFromQMET && (
                    <React.Fragment>
                      <Heat lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                      <Piece lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                      <QCNum lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              {isPiece && (
                <React.Fragment>
                  {isKolpino ?
                    <KolpinoProductType lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                    :
                    <ProductType lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  }
                  <Heat lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  <Piece lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  <GroupAtt lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  <QCNum lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                  {isKolpino && (
                    <React.Fragment>
                      <KolpinoPiece lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                      <KolpinoDrawNum lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {isDirtyWagons && (
            <DirtyWagons lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
          )}
          {isTerm && (
            <Term lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
          )}
          {isQualityOrService && (
            <React.Fragment>
              <CustomFields lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <IsMarriageShare lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <WeightBeforeProcessing lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <WeightAfterProcessing lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <MarriageShare lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <Weight lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
            </React.Fragment>
          )}
          <Note lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
          {isQualityOrService && account.role !== types.auth.AccountRole.Contractor && (
            <React.Fragment>
              <IsTopography lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyNote lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographySize lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographySizeId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyStep lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyStepId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyDistance lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyDistanceId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
            </React.Fragment>
          )}
          <Photo lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
          {isQualityOrService && account.role === types.auth.AccountRole.Contractor && (
            <React.Fragment>
              <IsTopography lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyNote lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographySize lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographySizeId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyStep lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyStepId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyDistance lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
              <TopographyDistanceId lookAndFeel = { lookAndFeel } dispatch = { dispatch } />
            </React.Fragment>
          )}
          <SubmitContainer lookAndFeel = { lookAndFeel }>
            <Button
              variant = { lookAndFeel.submitButtonVariant }
              onTap = { onSubmitHandler }
              label = { acceptText }
            />
          </SubmitContainer>
        </FormContainer>
        <TwoActionDialog 
          variant = { lookAndFeel.submitErrorDialogVariant } 
          opened = { submitErrorOpened || isDouble }
          caption = 'Ошибка'
          message = { isDouble ? 'Найден дубль позиции' : submitError }
          isDanger
          withoutCancel
          onAction = { onActionSubmitErrorHandler }
        />
        <TwoActionDialog 
          variant = { lookAndFeel.submitErrorDialogVariant } 
          opened = { closeConfirmOpened }
          caption = 'Сохранить информацию?'
          message = 'Позиция будет сохранена без проверки на обязательность заполнения полей'
          cancelLabel = 'Нет'
          actionLabel = 'Да'
          onAction = { onRequestSaveAcceptHandler }
          onCancel = { onRequestSaveCancelHandler }
        />
      </Container>
      <CertDownloadDialog variant = { lookAndFeel.certDownloadDialogVariant } />
    </Drawer>
  );
};
